<template>
    <div>
      <inqueryQmaLvTable v-if="qma === 0" :qma="qma" ref="inqueryQmaLvTable"></inqueryQmaLvTable>
      <inqueryQmaPitTable v-if="qma === 1" :qma="qma" ref="inqueryQmaPitTable"></inqueryQmaPitTable>
      <inqueryQmaPivsTable v-if="qma === 2" :qma="qma" ref="tableInqueryQmaPivs"></inqueryQmaPivsTable>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import Multiselect from 'vue-multiselect'
import inqueryQmaPivsTable from '../../inqueryQmaPivs/components/inqueryQmaPivsTable/inqueryQmaPivsTable.vue'
import inqueryQmaPitTable from '../../inqueryQmaPit/components/inqueryQmaPitTable/inqueryQmaPitTable.vue'
import inqueryQmaLvTable from '../../inqueryQmaLv/components/inqueryQmaLvTable/inqueryQmaLvTable.vue'
// import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'inqueryQmaTable',
  components: {Multiselect, inqueryQmaPivsTable, inqueryQmaPitTable, inqueryQmaLvTable},
  mixins: [ ActionsForm, ExpenseMixin ],
  props: ['qma'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    search (data, qma) {
      if (qma === 0) {
        this.$refs.inqueryQmaLvTable.formSearch = data
        this.$refs.inqueryQmaLvTable.onSearch()
      }
      if (qma === 1) {
        this.$refs.inqueryQmaPitTable.formSearch = data
        this.$refs.inqueryQmaPitTable.onSearch()
      }
      if (qma === 2) {
        this.$refs.tableInqueryQmaPivs.formSearch = data
        this.$refs.tableInqueryQmaPivs.onSearch()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/inqueryQmaTable/inqueryQmaTable.vue